module.exports = __webpack_public_path__ + "img/ar.0b7cfca.svg";